module.exports = __webpack_public_path__ + "assets/img/mecha-fb29d7f7.png";